module.exports = __webpack_public_path__ + "static/img/4906_phase_function_Paper_Points.d1b49d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4906_phase_function_Paper_Points.png
// module id = HzZh
// module chunks = 0